import { render } from "./settings_modal.vue?vue&type=template&id=5ba8f24c"
import script from "./settings_modal.js?vue&type=script&lang=js&external"
export * from "./settings_modal.js?vue&type=script&lang=js&external"

import "./settings_modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__